import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "translation/useTranslation";
import { Button, Field, Input, NativeSelect } from "components/ui";

export default function CalculationExclusion({ register, watch, handleSubmit, onSubmit }) {
  const dispatch = useDispatch();

  const { editableTranslate } = useTranslation();

  const [showEmployeeMissingMonthsExclusionSetting, setShowEmployeeMissingMonthsExclusionSetting] = useState(false);
  const [showEmployeeMinimumDaysExclusionSetting, setShowEmployeeMinimumDaysExclusionSetting] = useState(false);

  const employeeMissingMonthExclusionEnabled = watch('employee_missing_months_exclusion_enabled');
  const employeeMinimumDaysExclusionEnabled = watch('employee_minimum_days_exclusion_enabled');

  useEffect(() => {
    if (employeeMissingMonthExclusionEnabled) {
      setShowEmployeeMissingMonthsExclusionSetting(true);
    } else {
      setShowEmployeeMissingMonthsExclusionSetting(false);
    }
  }, [employeeMissingMonthExclusionEnabled]);

  useEffect(() => {
    if (employeeMinimumDaysExclusionEnabled) {
      setShowEmployeeMinimumDaysExclusionSetting(true);
    } else {
      setShowEmployeeMinimumDaysExclusionSetting(false);
    }
  }, [employeeMinimumDaysExclusionEnabled]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-md-12">
          <h5>{editableTranslate('calculation.debugger.exclusion.minimum_performance')}</h5>
          <div className="form-row">
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.employee_balanced_scorecard_result')}>
                <Input type="number" number step={1} {...register('employee_balanced_scorecard_result')} data-testid="employee-balanced-scorecard-result-input" />
              </Field>
            </div>
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.minimum_performance_result')}>
                <Input type="number" number step={1} {...register('minimum_performance_result')} data-testid="minimum-performance-result-input" />
              </Field>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <h5>{editableTranslate('calculation.debugger.exclusion.missing_months_exceeded')}</h5>
          <div className="form-row">
            <div className="form-group col-md-6">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" value={true} {...register('employee_missing_months_exclusion_enabled')} data-testid="employee-missing-months-exclusion-enabled-checkbox" />
                <label className="form-check-label ml-1">
                  {editableTranslate('calculation.debugger.employee_missing_months.exclusion_enabled')}
                </label>
              </div>
            </div>
          </div>
          {
            showEmployeeMissingMonthsExclusionSetting &&
            <>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.employee_missing_months')}>
                    <Input type="number" number min={0} max={12} step={1} placeholder="0-12" {...register('employee_missing_months')} data-testid="employee-missing-months-input" />
                  </Field>
                </div>
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.employee_missing_months.month_treshold')}>
                    <Input type="number" number min={0} max={12} placeholder="0-12" {...register('employee_missing_months_exclusion_month_threshold')} data-testid="employee-missing-months-exclusion-month-threshold-input" />
                  </Field>
                </div>
              </div>
            </>
          }
        </div>
        <div className="col-md-12">
          <h5>{editableTranslate('calculation.debugger.exclusion.manually_excluded')}</h5>
          <div className="form-row">
            <div className="form-group col-md-6">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" value={true} {...register('employee_manually_excluded')} data-testid="employee-manually-excluded-checkbox" />
                <label className="form-check-label ml-1">
                  {editableTranslate('calculation.debugger.employee_manually_excluded')}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <h5>{editableTranslate('calculation.debugger.exclusion.employee_employment')}</h5>
          <div className="form-row">
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.employee_employment.start_date')} htmlFor="employee-employment-start-date">
                <input id="employee-employment-start-date" type="date" className="form-control" {...register('employee_employment_start_date')} data-testid="employee-employment-start-date-input" />
              </Field>
            </div>
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.employee_employment.exit_date')} htmlFor="employee-employment-exit-date">
                <input id="employee-employment-exit-date" type="date" className="form-control" {...register('employee_employment_exit_date')} data-testid="employee-employment-exit-date-input" />
              </Field>
            </div>
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.employee_employment.minimum_employment_months')}>
                <Input type="number" number min={0} max={12} placeholder="0-12" {...register('employee_minimum_employment_months')} data-testid="employee-minimum-employment-months-input" />
              </Field>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <h5>{editableTranslate('calculation.debugger.exclusion.minimum_days')}</h5>
          <div className="form-row">
            <div className="form-group col-md-6">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" value={true} {...register('employee_minimum_days_exclusion_enabled')} data-testid="employee-minimum-days-exclusion-enabled-checkbox" />
                <label className="form-check-label ml-1">
                  {editableTranslate('calculation.debugger.exclusion.employee_minimum_days_exclusion_enabled')}
                </label>
              </div>
            </div>
          </div>
          {
            showEmployeeMinimumDaysExclusionSetting &&
            <>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.exclusion.employee_working_days_per_week')}>
                    <Input type="number" number min={0} max={5} step={1} placeholder="0-5" {...register('employee_working_days_per_week')} data-testid="employee-working-days-per-week-input" />
                  </Field>
                </div>
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.exclusion.employee_absence_days')}>
                    <Input type="number" number min={0} max={365} step={1} placeholder="0-365" {...register('employee_absence_days')} data-testid="employee-absence-days-input" />
                  </Field>
                </div>
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.exclusion.budget_working_days')}>
                    <Input type="number" number min={0} max={365} step={1} placeholder="0-365" {...register('budget_working_days')} data-testid="budget-working-days-input" />
                  </Field>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.exclusion_day_threshold')}>
                    <Input type="number" number {...register('exclusion_day_threshold')} data-testid="exclusion-day-threshold-input" />
                  </Field>
                </div>
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.exclusion_day_threshold_type')}>
                    <NativeSelect {...register('exclusion_day_threshold_type')} data-testid="exclusion-day-threshold-type-select">
                      <option value={'percent'}>% (percentage)</option>
                      <option value={'absolute'}>days</option>
                    </NativeSelect>
                  </Field>
                </div>
              </div>
            </>
          }
        </div>
        <div className="col-md-12">
          <div className="form-row">
            <div className="form-group col-md-6">
              <Button type="submit" variant="primary" data-testid="submit-button">Submit</Button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
